export const fetcher = (...args: [RequestInfo, RequestInit?]) => fetch(...args).then((res) => res.json())